<template>
  <v-card v-if="item" class="mx-auto">
    <v-img max-height="300" class="align-end" :src="img(item.img)">
      <v-spacer></v-spacer>
      <v-menu v-if="currentUser && currentUser.role && 'admin' in currentUser.role" right top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item-group>
            <v-list-item @click="onEdit()">
              <v-list-item-icon>
                <v-icon>edit</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item @click="onDelete()">
              <v-list-item-icon>
                <v-icon>delete</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <v-card-title
        :class="['justify-center', 'white--text', item.color || 'primary']"
        v-text="item.name.toUpperCase()"
      ></v-card-title>
    </v-img>
    <v-card-text class="text-center">
      <div v-if="item.priceAfterDiscount < item.price">
        <h3 class="text--disabled">${{item.price}}</h3>
        <h3 class="primary--text display-1">${{item.priceAfterDiscount}}</h3>
        <h3 class="primary--text title">You save ${{item.saving}}</h3>
      </div>
      <div v-else>
        <h3 class="text--disabled">${{item.price}}</h3>
        <h3 class="primary--text display-1">${{item.price}}</h3>
        <h3 class="primary--text title">You save ${{item.saving}}</h3>
      </div>
    </v-card-text>

    <v-data-table
      hide-default-footer
      hide-default-header
      dense
      :headers="headers"
      :items="item.features"
      item-key="name"
    >
      <template v-slot:item.max="{ item }">{{ featureValue(item.max) }}</template>
    </v-data-table>

    <v-card-actions class="primary--text title justify-center">
      <v-btn v-if="checkout" outlined block color="primary" @click="onChangePlan()">Change Plan</v-btn>
      <v-btn
        v-else-if="item.price == 0"
        outlined
        block
        color="primary"
        @click="onCheckout(item)"
      >JOIN FOR FREE</v-btn>
      <v-btn v-else outlined block color="primary" @click="onCheckout(item)">Trial 30 days</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import planC from "@/assets/bluetheme/pricing/team.png";
import { mapGetters } from "vuex";

export default {
  name: "ProductCard",
  components: {},
  props: {
    item: {
      type: Object,
      default: null
    },
    checkout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Feature",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Max Value", value: "max" }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  methods: {
    onChangePlan() {
      this.$emit("cancelCheckout", true);
    },
    onCheckout(val) {
      this.$emit("checkout", val);
    },
    onEdit() {
      this.$emit("edit", this.item);
    },
    onDelete() {
      this.$emit("delete", this.item);
    },
    featureValue(val) {
      if (val == -1) {
        return "∞";
      } else if (val == -2) {
        return "yes";
      } else {
        return val;
      }
    },
    img(url) {
      if (url) {
        return url;
      } else {
        return planC;
      }
    }
  }
};
</script>
<style></style>
